module.exports = __webpack_public_path__ + "img/step2.3cd48ce2.png";